import RescheduleInterviewDialog from "./RescheduleInterviewDialog";

export default RescheduleInterviewDialog;